import * as React from 'react';
import { withRouteData } from 'react-static';

import TwitterFeedComponent from '../../../components/HomePage/Twitter/TwitterFeed';
import { Tweet } from '../../../GraphQL';

interface TwitterFeedProps {
  twitterFeed: Tweet[];
}

const TwitterFeed: React.SFC<TwitterFeedProps> = ({ twitterFeed }) => (
  <TwitterFeedComponent twitterFeed={twitterFeed} />
);

export default withRouteData(TwitterFeed);



// WEBPACK FOOTER //
// /www/client/src/containers/HomePage/TwitterFeed/TwitterFeed.tsx